export const BONUS_REPORT_FOR_PLACE_PT_BR = {
	title: "Bônus",
};

export type BonusReportForPlaceTranslations = typeof BONUS_REPORT_FOR_PLACE_PT_BR;
